import { fromJS } from 'immutable';

const PREFIX = 'FILES/';
export const UPLOAD = `${PREFIX}UPLOAD`;
export const UPLOAD_REQUEST = `${PREFIX}UPLOAD_REQUEST`;
export const UPLOAD_SUCCESS = `${PREFIX}UPLOAD_SUCCESS`;
export const UPLOAD_ERROR = `${PREFIX}UPLOAD_ERROR`;

export const EDIT = `${PREFIX}EDIT`;
export const EDIT_REQUEST = `${PREFIX}EDIT_REQUEST`;
export const EDIT_SUCCESS = `${PREFIX}EDIT_SUCCESS`;
export const EDIT_ERROR = `${PREFIX}EDIT_ERROR`;

export const REMOVE = `${PREFIX}REMOVE`;
export const REMOVE_REQUEST = `${PREFIX}REMOVE_REQUEST`;
export const REMOVE_SUCCESS = `${PREFIX}REMOVE_SUCCESS`;
export const REMOVE_ERROR = `${PREFIX}REMOVE_ERROR`;

export const LOAD_FILES = PREFIX + 'LOAD_FILES';

export function loadFiles(ids) {
  return {
    type: LOAD_FILES,
    payload: {
      ids,
    },
  };
}

export function upload(files, url) {
  return {
    type: UPLOAD,
    payload: {
      files,
      url,
    },
  };
}

export function uploadRequest(url) {
  return {
    type: UPLOAD_REQUEST,
    payload: {
      url,
    },
  };
}

export function uploadSuccess(data, url) {
  return {
    type: UPLOAD_SUCCESS,
    payload: {
      ...data,
      url,
    },
  };
}

export function uploadError(url, errors) {
  return {
    type: UPLOAD_ERROR,
    url,
    errors: fromJS([errors]),
  };
}

export function edit(id, name) {
  return {
    type: EDIT,
    payload: {
      id,
      name,
    },
  };
}


export function editRequest(id, name) {
  return {
    type: EDIT_REQUEST,
    payload: {
      id,
      name,
    },
  };
}

export function editSuccess(id, file) {
  return {
    type: EDIT_SUCCESS,
    payload: {
      id,
      file,
    },
  };
}

export function editError(errors) {
  return {
    type: EDIT_ERROR,
    errors: fromJS(errors),
  };
}

export function remove(id) {
  return {
    type: REMOVE,
    payload: {
      id,
    },
  };
}


export function removeRequest(id) {
  return {
    type: REMOVE_REQUEST,
    payload: {
      id,
    },
  };
}

export function removeSuccess(id) {
  return {
    type: REMOVE_SUCCESS,
    payload: {
      id,
    },
  };
}

export function removeError(errors) {
  return {
    type: REMOVE_ERROR,
    errors: fromJS(errors),
  };
}
